/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React from "react";

import Badge from "../../common/Badge";

import { formatDate } from "../../../helpers/date";

export const PTOREQUEST_COLUMNS = [
  {
    Header: "Start Date",
    accessor: "start_date",
    id: "start_date",
    maxWidth: 120,
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : "--")
  },
  {
    Header: "End Date",
    accessor: "end_date",
    id: "end_date",
    maxWidth: 120,
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : "--")
  },
  {
    Header: "Status",
    accessor: "status",
    id: "status.label",
    Cell: ({ value }) => (
      <Badge
        className="fixed-width badge-big"
        color={value ? value.color : "#ccc"}
      >
        {value ? value.label : "--"}
      </Badge>
    ),
    minWidth: 200
  },
  {
    Header: "Total Duration",
    accessor: "duration",
    id: "duration",
    maxWidth: 120
  },
  {
    Header: "Reason",
    accessor: "reason",
    id: "reason.label",
    Cell: ({ value, row }) =>
      value?.label || row?._original?.type?.label || "--",
    maxWidth: 120
  },
  {
    Header: "Requested on",
    accessor: "created_on",
    id: "created_on",
    maxWidth: 120,
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : "--")
  },
  {
    Header: "Approved By",
    accessor: "initial_approval_by",
    id: "initial_approval_by.full_name",
    Cell: ({ value }) => value?.full_name || "--",
    maxWidth: 140
  },
  {
    Header: "Approved On",
    accessor: "initial_approval_on",
    id: "initial_approval_on",
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : "--"),
    maxWidth: 120
  },
  {
    Header: "Declined By",
    accessor: "declined_by",
    id: "declined_by.full_name",
    Cell: ({ value }) => value?.full_name || "--",
    maxWidth: 140
  },
  {
    Header: "Declined On",
    accessor: "declined_on",
    id: "declined_on",
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : "--"),
    maxWidth: 120
  }
];

export const generatePtoColumnsMobile = (row) => [
  {
    key: "Start Date",
    label: row.original.start_date
      ? formatDate(row.original.start_date, "MM/dd/yyyy")
      : "--"
  },
  {
    key: "End Date",
    label: row.original.end_date
      ? formatDate(row.original.end_date, "MM/dd/yyyy")
      : "--"
  },
  {
    key: "Status",
    label: row.original.status?.label || "--"
  },
  {
    key: "Total Duration",
    label: row.original.duration || "--"
  },
  {
    key: "Type",
    label: row.original.type?.label || "--"
  },
  {
    key: "Requested on",
    label: row.original.created_on
      ? formatDate(row.original.created_on, "MM/dd/yyyy")
      : "--"
  },
  {
    key: "Initial Approver",
    label: row.original.initial_approval_by?.full_name || "--"
  },
  {
    key: "Initial Approval On",
    label: row.original.initial_approval_on
      ? formatDate(row.original.initial_approval_on, "MM/dd/yyyy")
      : "--"
  },
  {
    key: "Final Approver",
    label: row.original.final_approval_by?.full_name || "--"
  },
  {
    key: "Final Approval On",
    label: row.original.final_approval_on
      ? formatDate(row.original.final_approval_on, "MM/dd/yyyy")
      : "--"
  },
  {
    key: "Decliner",
    label: row.original.declined_by?.full_name || "--"
  },
  {
    key: "Declined On",
    label: row.original.declined_on
      ? formatDate(row.original.declined_on, "MM/dd/yyyy")
      : "--"
  }
];
